import React from 'react';
import { Link } from 'react-router-dom';

export const PrivacyPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">隐私政策</h1>
      <p className="text-sm text-gray-500 mb-8">最后更新：2025年4月</p>

      <div className="prose prose-gray max-w-none space-y-6 text-gray-700 leading-relaxed">
        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">1. 信息收集</h2>
          <p>在您使用 AI少儿编程学习平台（以下简称"本平台"）时，我们可能收集以下信息：</p>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>注册信息</strong>：用户名、邮箱地址。</li>
            <li><strong>学习数据</strong>：项目进度、模型训练记录、采样数据。</li>
            <li><strong>使用数据</strong>：访问日志、浏览器类型、设备信息。</li>
            <li><strong>上传内容</strong>：您主动上传的图片等素材文件。</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">2. 信息使用</h2>
          <p>我们收集的信息仅用于以下目的：</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>提供和维护平台服务。</li>
            <li>个性化学习体验和内容推荐。</li>
            <li>改进平台功能和用户体验。</li>
            <li>发送与服务相关的通知（如账户验证、密码重置）。</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">3. 信息保护</h2>
          <p>我们采取合理的技术和管理措施保护您的个人信息：</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>所有数据传输使用 HTTPS 加密。</li>
            <li>密码采用加盐哈希存储，不以明文形式保存。</li>
            <li>严格限制数据访问权限，仅授权人员可接触用户数据。</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">4. 信息共享</h2>
          <p>我们不会将您的个人信息出售或分享给第三方，以下情况除外：</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>获得您的明确同意。</li>
            <li>法律法规要求或司法、行政机关依法要求提供。</li>
            <li>为保护本平台及用户的合法权益。</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">5. 用户权利</h2>
          <p>您有权：</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>访问和查看您的个人信息。</li>
            <li>更正不准确的信息。</li>
            <li>请求删除您的账户和相关数据。</li>
            <li>撤回已授予的同意。</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Cookie 使用</h2>
          <p>本平台使用 Cookie 和类似技术来维持登录状态和改善用户体验。您可以通过浏览器设置管理 Cookie 偏好。</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">7. 政策更新</h2>
          <p>我们可能会不定期更新本隐私政策。重大变更将通过平台通知或邮件告知您。继续使用本平台即表示您同意修订后的政策。</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">8. 联系我们</h2>
          <p>
            如您对本隐私政策有任何疑问，请通过
            <Link to="/contact" className="text-blue-600 hover:underline"> 联系我们 </Link>
            页面与我们取得联系。
          </p>
        </section>
      </div>
    </div>
  );
};
